import template from '@jsep-plugin/template';
import jsep from 'jsep';
import { getIsIntrinsicType } from '../helpers';
jsep.plugins.register(template);
export const parseAsJsepExpression = (str) => jsep(str);
export const isExpressionSyntaxWrapped = (arg) => {
    return typeof arg === 'string' && arg.startsWith('${') && arg.endsWith('}');
};
export const stripExpressionSyntax = (arg) => {
    if (typeof arg !== 'string') {
        return arg;
    }
    return arg.replace(/\${/g, '').replace(/}/g, '');
};
export const isTemplateLiteral = (str) => {
    return str.length > 0 && str.charAt(0) === '`' && str.charAt(str.length - 1) === '`';
};
export const isReferenceOnly = (exp) => {
    return exp.type === 'Identifier' || exp.type === 'MemberExpression';
};
export const getArrayType = (type) => {
    if (type === 'Array' || type === 'array') {
        return 'any';
    }
    else if (getIsIntrinsicType(type)) {
        return null;
    }
    else {
        const arrayTypeMatches = type.match(/^Array<(\w.*)>$/i);
        return arrayTypeMatches && arrayTypeMatches.length > 1
            ? arrayTypeMatches[1]
            : null;
    }
};
export const getRootHandle = (handle) => {
    return !!handle.parent ? getRootHandle(handle.parent) : handle;
};
export const argsToString = (args) => {
    let s = '';
    args.forEach((a, i) => {
        if (i !== 0) {
            s += ', ';
        }
        s += a.value;
    });
    return s;
};
//# sourceMappingURL=helpers.js.map